<div appDialogSelectable appDialogKeyboardEnabled>
  <div
    class="atlas-case-validation-dialog"
    (cdkDragStarted)="dialogBoundryService.handleDragStart($event)"
    (cdkDragEnded)="dialogBoundryService.handleDragEnd($event)"
    cdkDragRootElement=".cdk-overlay-pane"
    cdkDrag
  >
    <div appDialogDragArea cdkDragHandle></div>
    <div class="modal-content">
      <div class="modal-header">
        <div class="modal-header-title">Case Validation · {{ data?.caseNumber || '-' }}</div>
        <div class="modal-buttons">
          <div (click)="close()">
            <img src="/assets/icons/Close White.svg" alt="Close" />
          </div>
        </div>
      </div>

      <div class="modal-content-body case-validation-dialog-body">
        <div class="case-validation-shell">
          <div *ngIf="loading" class="case-validation-state-card">
            Loading case validation...
          </div>

          <div *ngIf="!loading && error" class="case-validation-state-card case-validation-state-card-error">
            {{ error }}
          </div>

          <ng-container *ngIf="!loading && !error">
            <section class="validation-section">
              <div class="validation-section-header">
                <div class="validation-section-title">Travel</div>
                <div class="validation-section-subtitle">
                  {{ travelChecks.length }} {{ travelChecks.length === 1 ? 'check' : 'checks' }}
                </div>
              </div>

              <div *ngIf="travelChecks.length; else noTravelChecks" class="validation-check-list">
                <article
                  *ngFor="let check of travelChecks; trackBy: trackByCheck"
                  class="validation-check-card"
                  [ngClass]="getColorClass(check.color)"
                >
                  <div class="validation-check-label">Check</div>
                  <div class="validation-check-topline">
                    <div class="validation-check-main">
                      <div class="validation-check-field">{{ check.field }}</div>
                    </div>
                    <span class="validation-check-color" [attr.title]="check.color || 'Unknown'"></span>
                  </div>
                  <div class="validation-check-caption">Reasoning</div>
                  <div class="validation-check-reasoning">{{ check.reasoning }}</div>
                  <div class="validation-check-accent"></div>
                </article>
              </div>
            </section>

            <ng-template #noTravelChecks>
              <div *ngIf="checks.length" class="case-validation-state-card">
                No travel checks returned.
              </div>
            </ng-template>

            <section *ngFor="let section of otherSections" class="validation-section">
              <div class="validation-section-header">
                <div class="validation-section-title">{{ getSectionTitle(section.type) }}</div>
                <div class="validation-section-subtitle">
                  {{ section.checks.length }} {{ section.checks.length === 1 ? 'check' : 'checks' }}
                </div>
              </div>

              <div class="validation-check-list">
                <article
                  *ngFor="let check of section.checks; trackBy: trackByCheck"
                  class="validation-check-card"
                  [ngClass]="getColorClass(check.color)"
                >
                  <div class="validation-check-label">Check</div>
                  <div class="validation-check-topline">
                    <div class="validation-check-main">
                      <div class="validation-check-field">{{ check.field }}</div>
                    </div>
                    <span class="validation-check-color" [attr.title]="check.color || 'Unknown'"></span>
                  </div>
                  <div class="validation-check-caption">Reasoning</div>
                  <div class="validation-check-reasoning">{{ check.reasoning }}</div>
                  <div class="validation-check-accent"></div>
                </article>
              </div>
            </section>

            <div *ngIf="!checks.length" class="case-validation-state-card">
              No validation checks returned.
            </div>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
</div>
